import { render, staticRenderFns } from "./ClockWidget.vue?vue&type=template&id=4baf496a&scoped=true"
import script from "./ClockWidget.vue?vue&type=script&lang=js"
export * from "./ClockWidget.vue?vue&type=script&lang=js"
import style0 from "./ClockWidget.vue?vue&type=style&index=0&id=4baf496a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf496a",
  null
  
)

export default component.exports